<template>
  <div>
    <div id="calendar" class="portal-calendar"></div>
  </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';

  const MonChange = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  export default {
    name: 'portal-calendar',
    props: ['schedules'],
    data() {
      return {
        MonChange,
        yearMonth: '',
        getEvents: [],
        events: [],
        getIds: [],
      };
    },
    watch: {
      events() {
        this.eventSetting();
        this.changeCalendar();
      },
    },
    methods: {
      changeCalendar() {
        const self = this;
        self.cal = $('#calendar');
        const events = this.getEvents;
        self.cal.fullCalendar('removeEvents');
        self.cal.fullCalendar('addEventSource', events);
      },
      drawCalendar() {
        const self = this;
        self.cal = $('#calendar');
        const args = {
          locale: 'ko',
          height: 'auto',
          minTime: '09:00:00',
          maxTime: '21:00:00',
          header: {
            left: '',
            center: 'title',
            right: 'today prev,next',
          },
          allDaySlot: false,
          slotEventOverlap: false,
          timeFormat: 'HH:mm',
          events: self.getEvents,
        };

        self.cal.fullCalendar(args);

        $('body').on('click', 'button.fc-prev-button', () => {
          /* eslint no-underscore-dangle: ["error", { "allow": ["_i"] }] */
          const today = String(self.cal.fullCalendar('getDate')._d);
          const todayY = today.slice(13, 15);
          const todayM = today.slice(4, 7);
          const yearMonth = `${todayY}${MonChange[todayM]}`;
          this.getEventData(yearMonth);
        });

        $('body').on('click', 'button.fc-next-button', () => {
          /* eslint no-underscore-dangle: ["error", { "allow": ["_i", "_d"] }] */
          const today = String(self.cal.fullCalendar('getDate')._d);
          const todayY = today.slice(13, 15);
          const todayM = today.slice(4, 7);
          const yearMonth = `${todayY}${MonChange[todayM]}`;
          this.getEventData(yearMonth);
        });
      },
      eventSetting() {
        const events = this.events;
        events.forEach((val) => {
          if (this.getIds.indexOf(val.id) === -1) {
            const startDateString = val.startDate.toString();
            const endDateString = val.endDate.toString();

            const sYear = startDateString.slice(0, 2);
            const sMonth = startDateString.slice(2, 4);
            const sDay = startDateString.slice(4);

            const eYear = endDateString.slice(0, 2);
            const eMonth = endDateString.slice(2, 4);
            const eDay = endDateString.slice(4);

            const startFormat = `20${sYear}-${sMonth}-${sDay}`;
            const endFormat = `20${eYear}-${eMonth}-${eDay}`;

            const backgroundColorSet = {
              PORTAL: 'rgba(20,153,223,0.75)',
              FOUNDATION: 'rgba(20,153,223,0.75)',
              CAMPUS: 'rgba(239,37,64,.75)',
              CENTER: 'rgba(3,181,75,.75)',
            };

            this.getEvents.push({
              id: val.id,
              title: val.title,
              backgroundColor: backgroundColorSet[val.type],
              borderColor: 'transparent',
              textColor: '#ffffff',
              start: startFormat,
              end: endFormat,
              url: val.url,
            });
            this.getIds.push(val.id);
          }
        });
      },
      getEventData(yearMonth) {
        axios.get(`/api/schedules?month=${yearMonth}`).then((response) => {
          this.events = response.data || [];
        }).catch((error) => {
          console.log(error.data);
        });
      },
    },
    mounted() {
      const getMoment = moment().locale('ko');
      /* eslint no-underscore-dangle: ["error", { "allow": ["_d"] }] */
      const today = String(getMoment._d);
      const todayY = today.slice(13, 15);
      const todayM = today.slice(4, 7);
      const yearMonth = `${todayY}${MonChange[todayM]}`;
      this.yearMonth = `${todayY}${MonChange[todayM]}`;
      this.getEventData(yearMonth);
      this.drawCalendar();
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// PortalCalendar.vue?6eb9e610